var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Spinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2d5eab",
    d: "M25,14h-2c-0.552,0-1-0.448-1-1V5c0-0.552,0.448-1,1-1h2c0.552,0,1,0.448,1,1v8 C26,13.552,25.552,14,25,14z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#199be2",
    d: "M25,44h-2c-0.552,0-1-0.448-1-1v-8c0-0.552,0.448-1,1-1h2c0.552,0,1,0.448,1,1v8 C26,43.552,25.552,44,25,44z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d62ab",
    d: "M34,25v-2c0-0.552,0.448-1,1-1h8c0.552,0,1,0.448,1,1v2c0,0.552-0.448,1-1,1h-8 C34.448,26,34,25.552,34,25z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#50e6ff",
    d: "M4,25v-2c0-0.552,0.448-1,1-1h8c0.552,0,1,0.448,1,1v2c0,0.552-0.448,1-1,1H5C4.448,26,4,25.552,4,25 z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d5eab",
    d: "M31.778,17.636l-1.414-1.414c-0.391-0.391-0.391-1.024,0-1.414l5.657-5.657 c0.391-0.391,1.024-0.391,1.414,0l1.414,1.414c0.391,0.391,0.391,1.024,0,1.414l-5.657,5.657 C32.802,18.027,32.169,18.027,31.778,17.636z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#35c1f1",
    d: "M10.565,38.849l-1.414-1.414c-0.391-0.391-0.391-1.024,0-1.414l5.657-5.657 c0.391-0.391,1.024-0.391,1.414,0l1.414,1.414c0.391,0.391,0.391,1.024,0,1.414l-5.657,5.657 C11.589,39.24,10.955,39.24,10.565,38.849z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#0078d4",
    d: "M30.364,31.778l1.414-1.414c0.391-0.391,1.024-0.391,1.414,0l5.657,5.657 c0.391,0.391,0.391,1.024,0,1.414l-1.414,1.414c-0.391,0.391-1.024,0.391-1.414,0l-5.657-5.657 C29.973,32.802,29.973,32.169,30.364,31.778z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d5eab",
    d: "M9.151,10.565l1.414-1.414c0.391-0.391,1.024-0.391,1.414,0l5.657,5.657 c0.391,0.391,0.391,1.024,0,1.414l-1.414,1.414c-0.391,0.391-1.024,0.391-1.414,0l-5.657-5.657 C8.76,11.589,8.76,10.955,9.151,10.565z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Spinner);
export default __webpack_public_path__ + "static/media/icons8-spinner.7379ebb70db475347a3529e62bcdfcf4.svg";
export { ForwardRef as ReactComponent };